import { Button } from '@components/styled/Button.styled';
import { Title } from '@components/styled/Title.styled';
import { Colors } from '@src/colors';
import styled from 'styled-components';
import { Header } from './components/styled/Header.styled';
import { RecalculateGroup } from './components/styled/RecalculateGroup.styled';
import { fontButtonDefault } from './typography.styled';

export const App = styled.div``;

export const Description = styled.div`
    font-family: 'Public Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 17px;
    line-height: 28px;
    max-width: 670px;
`;

export const Container = styled.div`
    position: relative;

    padding: 50px;
    margin-bottom: 100px;

    box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.1);
    border-radius: 30px;

    ${Button}.reset {
        position: absolute;
        top: 20px;
        right: 20px;

        height: 48px;

        label {
            ${fontButtonDefault}
            color: ${Colors.vacasaBlue}
        }
    }
`;

export const EstimatorApp = styled.div`
    margin-bottom: 50px;

    > svg {
        margin-bottom: 85px;
    }

    ${Title} {
        margin-bottom: 15px;
    }
`;

export const HomeDetails = styled.div`
    ${Container} {
        display: flex;
        flex-wrap: wrap;
        row-gap: 45px;
        column-gap: 45px;
    }
`;

export const EstimatedRentalRevenue = styled.div`
    ${Header} {
        margin-bottom: 35px;
    }

    ${RecalculateGroup} {
        margin-bottom: 17px;
    }
`;

export const MinRateImpactCalculator = styled.div`
    ${Container} {
        display: flex;
        flex-direction: column;
        row-gap: 35px;
        column-gap: 35px;
    }
`;
export const OwnerHolds = styled.div``;

export const Form = styled.form``;
